// Centralized route → human label map (Hindi + English) used by BackBar breadcrumbs.
// Edit one place to change navigation labels everywhere.
export const ROUTE_LABELS = {
  // Home / Dashboards
  '/dashboard': { hi: 'Dashboard', en: 'Dashboard' },
  '/school-dashboard': { hi: 'School Dashboard', en: 'School Dashboard' },
  '/parent-dashboard': { hi: 'Parent Dashboard', en: 'Parent Dashboard' },
  '/portal-dashboard': { hi: 'Portal', en: 'Portal' },

  // ERP / school modules
  '/schools': { hi: 'Schools', en: 'Schools' },
  '/classes': { hi: 'Classes', en: 'Classes' },
  '/students': { hi: 'Students', en: 'Students' },
  '/teachers': { hi: 'Teachers', en: 'Teachers' },
  '/attendance': { hi: 'Attendance', en: 'Attendance' },
  '/exams': { hi: 'Exams', en: 'Exams' },
  '/timetable': { hi: 'Timetable', en: 'Timetable' },
  '/calendar': { hi: 'Calendar', en: 'Calendar' },
  '/fees': { hi: 'Fees', en: 'Fees' },
  '/fee-structure': { hi: 'Fee Structure', en: 'Fee Structure' },
  '/communication': { hi: 'Communication', en: 'Communication' },
  '/complaints': { hi: 'Complaints', en: 'Complaints' },
  '/reports': { hi: 'Reports', en: 'Reports' },
  '/transport': { hi: 'Transport', en: 'Transport' },
  '/hr-payroll': { hi: 'HR & Payroll', en: 'HR & Payroll' },
  '/library': { hi: 'Library', en: 'Library' },
  '/leave-management': { hi: 'Leave Management', en: 'Leave Management' },
  '/leave-apply': { hi: 'Leave Apply', en: 'Leave Apply' },
  '/leave-requests': { hi: 'Leave Requests', en: 'Leave Requests' },
  '/emergency-exit': { hi: 'Emergency Exit', en: 'Emergency Exit' },

  // AI / wallet / setup
  '/ai': { hi: 'AI Features', en: 'AI Features' },
  '/ai-features': { hi: 'AI Features', en: 'AI Features' },
  '/ai-usage': { hi: "Today's AI Usage", en: "Today's AI Usage" },
  '/wallet': { hi: 'Wallet', en: 'Wallet' },
  '/setup-guide': { hi: 'Setup Guide', en: 'Setup Guide' },
  '/school-analytics': { hi: 'School Analytics', en: 'School Analytics' },

  // Admission / payments
  '/admission-engine': { hi: 'Admission Engine', en: 'Admission Engine' },
  '/padhai-emi': { hi: 'Padhai EMI', en: 'Padhai EMI' },
  '/nbfc-approval': { hi: 'NBFC Approval', en: 'NBFC Approval' },

  // Platform admin
  '/lead-crm': { hi: 'Lead CRM', en: 'Lead CRM' },
  '/lead-nurturing': { hi: 'Lead Nurturing', en: 'Lead Nurturing' },
  '/follow-ups': { hi: 'Follow-ups', en: 'Follow-ups' },
  '/feature-editor': { hi: 'Feature Editor', en: 'Feature Editor' },
  '/data-tasks': { hi: 'Data Tasks', en: 'Data Tasks' },
  '/data-export': { hi: 'Data Export', en: 'Data Export' },
  '/audit-logs': { hi: 'Audit Logs', en: 'Audit Logs' },
  '/scheduler': { hi: 'Scheduler', en: 'Scheduler' },
  '/notifications': { hi: 'Notifications', en: 'Notifications' },
  '/analytics': { hi: 'Analytics', en: 'Analytics' },
  '/campaign-manager': { hi: 'Campaign Manager', en: 'Campaign Manager' },
  '/school-finder': { hi: 'School Finder', en: 'School Finder' },
  '/udise': { hi: 'UDISE', en: 'UDISE' },
  '/social-media': { hi: 'Social Media', en: 'Social Media' },
  '/newsletter': { hi: 'Newsletter', en: 'Newsletter' },
  '/whatsapp': { hi: 'WhatsApp', en: 'WhatsApp' },
  '/settings': { hi: 'Settings', en: 'Settings' },
  '/domain-settings': { hi: 'Domain Settings', en: 'Domain Settings' },
  '/documents': { hi: 'Documents', en: 'Documents' },
  '/doubt-history': { hi: 'Doubt History', en: 'Doubt History' },
  '/bulk': { hi: 'Bulk Import', en: 'Bulk Import' },
  '/bulk-import': { hi: 'Bulk Import', en: 'Bulk Import' },

  // Parent / portal pages (children of /portal-dashboard)
  '/portal-attendance': { hi: 'Attendance', en: 'Attendance' },
  '/portal-fees': { hi: 'Fees', en: 'Fees' },
  '/portal-announcements': { hi: 'Announcements', en: 'Announcements' },
  '/portal-complaints': { hi: 'Complaints', en: 'Complaints' },
  '/portal-bus-tracking': { hi: 'Bus Tracking', en: 'Bus Tracking' },
};

// Parent route map — drives breadcrumb trail.
// If a route is missing, breadcrumb will collapse to: Home › <current>.
export const ROUTE_PARENT = {
  // Portal pages → Portal Dashboard
  '/portal-attendance': '/portal-dashboard',
  '/portal-fees': '/portal-dashboard',
  '/portal-announcements': '/portal-dashboard',
  '/portal-complaints': '/portal-dashboard',
  '/portal-bus-tracking': '/portal-dashboard',
  // Leave drilldowns
  '/leave-apply': '/leave-management',
  '/leave-requests': '/leave-management',
  // Bulk variants
  '/bulk': '/students',
  '/bulk-import': '/students',
  // Padhai EMI / NBFC under Admission
  '/padhai-emi': '/admission-engine',
  '/nbfc-approval': '/admission-engine',
  '/fee-structure': '/fees',
  // AI usage under AI
  '/ai-usage': '/ai',
  '/ai-features': '/ai',
  // Domain settings under Settings
  '/domain-settings': '/settings',
};

export const labelFor = (path, language) => {
  const entry = ROUTE_LABELS[path];
  if (entry) return entry[language] || entry.en || path;
  // Fallback: humanize the slug
  const slug = path.replace(/^\//, '').replace(/-/g, ' ').trim();
  return slug.replace(/\b\w/g, (c) => c.toUpperCase()) || path;
};
